import en from './en.js'
import zh_cn from './zh_cn.js'
import ko from './ko.js'
import ru from './ru.js'
import japan from './japan.js'
import vi from './vi.js'

var locales = {
  en: en,
  zh_cn: zh_cn,
  ko: ko,
  ru: ru,
  vi: vi
}
export default locales
